export const Posts = ["RWO", "ITWO", "HRWO-A", "HRWO-B", "HRWO-C", "HRWO-D", "DWO", "AWO"] as const;
export type Post = (typeof Posts)[number];
